export const stringListToSentence = (candidates: string[]) => {
  if (candidates.length === 0) return '';

  const seperator = ', ';
  let output = candidates.join(seperator);
  const sepLocation = output.lastIndexOf(seperator);

  if (sepLocation > -1) {
    output = output.slice(0, sepLocation) + output.slice(sepLocation).replace(seperator, ' and ');
  }

  return output;
};
